import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, DeferLoadingStrategy } from '@spartacus/core';
import { GenericLinkModule, NavigationModule } from '@spartacus/storefront';
import { MyAccountModule } from '../my-account/my-account.module';
import { HeaderLinksComponent } from './header-links.component';

@NgModule({
  imports: [
    CommonModule,
    GenericLinkModule,
    NavigationModule,
    NgbDropdownModule,
    MatIconModule,
    MyAccountModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        NavigationComponent: {
          component: HeaderLinksComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    HeaderLinksComponent,
  ],
})
export class HeaderLinksModule {}
